module.exports = __webpack_public_path__ + "static/images/a9eb61a844de99c5d6bda323b0d02df7.png";